import classNames from 'classnames'

import {
  getIsGretaAIChatRowGenerating,
  getIsGretaAIChatRowNewReply,
} from '../../../GretaAIChat.utils'

import * as styles from './GretaAIChatChatListItemStatus.module.css'

function GretaAIChatChatListItemStatus({ className, status }) {
  return (
    <span
      className={classNames(className, {
        [styles.generating]: getIsGretaAIChatRowGenerating(status),
        [styles.newReply]: getIsGretaAIChatRowNewReply(status),
      })}
    />
  )
}

export default GretaAIChatChatListItemStatus
